import { SVGSprite } from "../flash/display";
import MonicaObject from "./MonicaObject";

export class Mark extends MonicaObject {

  public visible: boolean = false;

  private triangle: SVGElement = null;

  public createImage() {
    this.triangle = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    this.triangle.setAttribute('d', 'M -15 -15 L 0 15 L 15 -15 Z');
    this.triangle.setAttribute('fill', '#5B9BD5');


    let viewObj: Element;
    if (!this.spt) {
      viewObj = document.createElementNS('http://www.w3.org/2000/svg', 'g');
      viewObj.setAttribute('id', `${this.itemInfo.id}_${this.itemInfo.guid}`);
    } else {
      viewObj = this.spt.element;
    }
    viewObj.appendChild(this.triangle);

    if (this.spt === undefined) {
      this.spt = new SVGSprite(viewObj);
    }
    this.spt.x = this.itemInfo.x;
    this.spt.y = this.itemInfo.y;
    this.spt.update();

    this.updateTransforms();
  }

  /**
   * Translateのアップデート
   */
  updateTransforms() {
    this.spt.x = this.itemInfo.x;
    this.spt.y = this.itemInfo.y;
    if (Number.isNaN(this.spt.scaleX)) this.spt.scaleX = 1;
    if (Number.isNaN(this.spt.scaleY)) this.spt.scaleY = 1;

    this.spt.rotation = 0;
    this.spt.update();

    const pin = new SVGSprite(this.triangle);
    pin.rotation = this.itemInfo.rotation;
    pin.update();
  }
}